export default __webpack_public_path__ + "static/media/medaille-bdo-or-conception.ced44f84.png";